import { z } from "zod";
import { newPasswordSchema } from "@/shared/lib/passwordSchema";

// The invite token isn't in the form — it comes from the route param and is added by the mutation.
export const joinSchema = z.object({
  username: z
    .string()
    .trim()
    .min(3, "Minst 3 tecken")
    .max(24, "Högst 24 tecken"),
  password: newPasswordSchema,
});
export type JoinInput = z.input<typeof joinSchema>;
export type JoinValues = z.output<typeof joinSchema>;

export const loginSchema = z.object({
  username: z.string().trim().min(1, "Obligatoriskt"),
  password: z.string().min(1, "Obligatoriskt"),
});
export type LoginInput = z.input<typeof loginSchema>;
export type LoginValues = z.output<typeof loginSchema>;
